<mat-expansion-panel class="md-expansion-demo-width" #myPanel expanded="true">
  <mat-expansion-panel-header>
    <mat-panel-title>
      <div class="col-md-6"><h6>Shift Definition</h6></div>
      <div class="col-md-6" *ngIf="siteId !== '' && siteId !== 'default'">
        <h6>Site Id: {{ siteId }}</h6>
      </div>
    </mat-panel-title>
  </mat-expansion-panel-header>
  <form [formGroup]="formdata" #formDirective="ngForm" novalidate>
    <div class="row">
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
        <div class="form-group" *ngIf="shifts.length > 0">
          <div class="col-lg-12">
            <mat-table #table id="shift-table" [dataSource]="dataSource">
              <ng-container matColumnDef="shiftId">
                <mat-header-cell *matHeaderCellDef>Shift ID</mat-header-cell>
                <mat-cell *matCellDef="let shift; let rindex = index">
                  <input
                    matInput
                    type="number"
                    id="shiftId{{ rindex }}"
                    formControlName="shiftId{{ formControlIndex[rindex] }}"
                    placeholder="Enter Shift ID"
                    (change)="validateShiftId()"
                    [(ngModel)]="shift.shiftId"
                    (keypress)="numberOnly($event)"
                    [value]="shift.shiftId"
                    required
                  />
                </mat-cell>
              </ng-container>
              <ng-container matColumnDef="shiftName">
                <mat-header-cell *matHeaderCellDef
                  >Shift Name<span class="iep-required"
                    >*</span
                  ></mat-header-cell
                >
                <mat-cell *matCellDef="let shift; let rindex = index">
                  <mat-form-field>
                    <input
                      matInput
                      type="text"
                      id="shiftName{{ rindex }}"
                      formControlName="shiftName{{ formControlIndex[rindex] }}"
                      placeholder="Enter Shift name"
                      (change)="validateShiftName()"
                      [(ngModel)]="shift.shiftName"
                      [value]="shift.shiftName"
                      required
                    />
                    <mat-error
                      *ngIf="
                        isFieldHasError({
                          controlName: 'shiftName',
                          index: formControlIndex[rindex],
                          error: 'required'
                        })
                      "
                      >This field is required.</mat-error
                    >
                    <mat-error
                      *ngIf="
                        isFieldHasError({
                          controlName: 'shiftName',
                          index: formControlIndex[rindex],
                          error: 'maxlength'
                        })
                      "
                    >
                      Please provide name up to 50 Characters.
                    </mat-error>
                    <mat-error
                      *ngIf="
                        isFieldHasError({
                          controlName: 'shiftName',
                          index: formControlIndex[rindex],
                          error: 'pattern'
                        })
                      "
                    >
                      Only (& . - _ / : ,) special symbol allowed.
                    </mat-error>
                    <mat-error
                      *ngIf="
                        isFieldHasError({
                          controlName: 'shiftName',
                          index: formControlIndex[rindex],
                          error: 'whitespace'
                        })
                      "
                      >Please enter valid text.</mat-error
                    >
                  </mat-form-field>
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="shiftStart">
                <mat-header-cell *matHeaderCellDef
                  >Shift Start<span class="iep-required"
                    >*</span
                  ></mat-header-cell
                >
                <mat-cell *matCellDef="let shift; let rindex = index">
                  <mat-form-field>
                    <input
                      matInput
                      formControlName="shiftStart{{ formControlIndex[rindex] }}"
                      id="shiftStart{{ rindex }}"
                      type="time"
                      placeholder="HH:mm:ss"
                      (change)="validateTimeSlotsShiftStart($event, rindex)"
                      name="shiftStart{{ rindex }}"
                      [ngModel]="shift.shiftStart | date : 'HH:mm:ss'"
                      required
                    />
                  </mat-form-field>
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="shiftEnd">
                <mat-header-cell *matHeaderCellDef
                  >Shift End<span class="iep-required">*</span></mat-header-cell
                >
                <mat-cell *matCellDef="let shift; let rindex = index">
                  <mat-form-field>
                    <input
                      matInput
                      type="time"
                      formControlName="shiftEnd{{ formControlIndex[rindex] }}"
                      (change)="validateTimeSlotsShiftEnd($event, rindex)"
                      name="shiftEnd{{ rindex }}"
                      id="shiftEnd{{ rindex }}"
                      [ngModel]="shift.shiftEnd | date : 'HH:mm:ss'"
                      placeholder="HH:mm:ss"
                      required
                    />
                  </mat-form-field>
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="actions">
                <mat-header-cell *matHeaderCellDef></mat-header-cell>
                <mat-cell
                  *matCellDef="let shift; let rindex = index"
                  [ngClass]="'shiftActionClass'"
                >
                  <button
                    id="clearbtn"
                    class="button-primary"
                    (click)="clear(rindex)"
                  >
                    Clear
                  </button>
                  <button
                    [id]="rindex"
                    class="button-primary"
                    (click)="remove(rindex)"
                    *ngIf="shifts.length > 1"
                  >
                    Remove
                  </button>
                  <button
                    id="addbtn"
                    class="button-primary"
                    (click)="add()"
                    *ngIf="
                      shifts.length < maxNoOfShift &&
                      rindex === shifts.length - 1
                    "
                  >
                    Add
                  </button>
                </mat-cell>
              </ng-container>

              <mat-header-row
                *matHeaderRowDef="displayedColumns"
              ></mat-header-row>
              <mat-row
                *matRowDef="let shift; columns: displayedColumns"
              ></mat-row>
            </mat-table>
          </div>
        </div>
      </div>
    </div>
  </form>

  <mat-action-row>
    <div
      *ngIf="isOverlapShiftTime || isDuplicatedShiftId || isDuplicatedShiftName"
      class="col-xs-5 col-sm-5 col-md-5 col-lg-5"
    >
      <div
        class="alert alert-danger alert-normal-danger"
        *ngIf="isOverlapShiftTime"
      >
        Time shifts overlapping!
      </div>
      <div
        class="alert alert-danger alert-normal-danger"
        *ngIf="isDuplicatedShiftId"
      >
        Duplicated Shift ID!
      </div>
      <div
        class="alert alert-danger alert-normal-danger"
        *ngIf="isDuplicatedShiftName"
      >
        Duplicated Shift Name!
      </div>
    </div>

    <div class="col-xs-7 col-sm-7 col-md-7 col-lg-7">
      <button
        (click)="previousStep($event)"
        id="previousbtn"
        bciprimarybutton
        class="button-primary"
      >
        <span>
          <mat-icon
            aria-hidden="false"
            aria-label="weather icon"
            class="bosch-ic-arrow-left-frame"
            style="width: max-content"
          ></mat-icon> </span
        >Previous
      </button>
      <button
        type="submit"
        id="savebtn"
        bciprimarybutton
        class="button-primary"
        [disabled]="!isFormValid()"
        (click)="submitShifts()"
        style="margin-left: 3px"
      >
        <span>
          <mat-icon
            aria-hidden="false"
            aria-label="weather icon"
            class="bosch-ic-checkmark-frame"
            style="width: max-content"
          >
          </mat-icon> </span
        >Save
      </button>

      <button
        (click)="nextStep($event)"
        id="nextbtn"
        bciprimarybutton
        class="button-primary"
        style="margin-left: 3px"
      >
        Next
        <span>
          <mat-icon
            aria-hidden="false"
            aria-label="weather icon"
            class="bosch-ic-arrow-right-frame"
            style="width: max-content"
          ></mat-icon>
        </span>
      </button>
    </div>
  </mat-action-row>
</mat-expansion-panel>
